import { adminTypes } from "@admin/admin-types.di";
import { AdminDatasource } from "@admin/data/datasources/admin.datasource";
import { AdminImplRepository } from "@admin/data/repositories/admin.impl-repository";
import type { AdminRepository } from "@admin/domain/repositories/admin.repository";
import { UserCreateToSpatialLevelUseCase } from "@admin/domain/usecases/create-user-spatial-level.usecase";
import { SpatialLevelAddUserUseCase } from "@admin/domain/usecases/spatial-level-add-user.usecase";
import { SpatialLevelAddUseCase } from "@admin/domain/usecases/spatial-level-add.usecase";
import { SpatialLevelDeleteUseCase } from "@admin/domain/usecases/spatial-level-delete.usecase";
import { SpatialLevelUpdateUseCase } from "@admin/domain/usecases/spatial-level-update.usecase";
import { SpatialLevelsResumeGetByStationIdUseCase } from "@admin/domain/usecases/spatial-levels-resume-get-by-station-id.usecase";
import { StationUpdateUseCase } from "@admin/domain/usecases/station-update.usecase";
import { AssignedSpatialLevelsViewmodel } from "@admin/presentation/components/assignated-spatial-levels.viewmodel";
import { CreateUserModalViewModel } from "@admin/presentation/components/create-user-modal/create-user-modal.viewmodel";
import { PredefinedAlertSelectViewmodel } from "@admin/presentation/components/predefined-alert-select/predefined-alert-select.viewmodel";
import { SpatialLevelUpdateModalViewModel } from "@admin/presentation/components/spatial-level-modal/spatial-level-update-modal.viewmodel";
import { AdminResponsivePageViewmodel } from "@admin/presentation/pages/admin/admin-responsive-page.viewmodel";
import { AdminPageViewmodel } from "@admin/presentation/pages/admin/web/admin.viewmodel";
import { DiModuleBuilder } from "@iot-platform/core";
import { UserGetAllResumeUseCase } from "@iot-platform/user";
import { ContainerModule } from "inversify";

const webAdminModule = new DiModuleBuilder();

webAdminModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(AdminDatasource).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<AdminRepository>(adminTypes.repositories.AdminRepository).to(
            AdminImplRepository,
        );
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(StationUpdateUseCase).toSelf();
        bind(SpatialLevelUpdateUseCase).toSelf();
        bind(SpatialLevelsResumeGetByStationIdUseCase).toSelf();
        bind(SpatialLevelAddUseCase).toSelf();
        bind(SpatialLevelDeleteUseCase).toSelf();
        bind(UserGetAllResumeUseCase).toSelf();
        bind(SpatialLevelAddUserUseCase).toSelf();
        bind(UserCreateToSpatialLevelUseCase).toSelf();
    }),
    viewModels: new ContainerModule(({ bind }) => {
        bind(AdminPageViewmodel).toSelf();
        bind(AdminResponsivePageViewmodel).toSelf();
        bind(SpatialLevelUpdateModalViewModel).toSelf();
        bind(PredefinedAlertSelectViewmodel).toSelf();
        bind(AssignedSpatialLevelsViewmodel).toSelf();
        bind(CreateUserModalViewModel).toSelf();
    }),
}));

webAdminModule.registerModule();

export { webAdminModule };
